import React from 'react';
import PropTypes from 'prop-types';

import { CenteredContainer, Title, Text } from '@nerdwallet/currency';
import { NOT_DESKTOP_MAX_WIDTH } from '@nerdwallet/global-nav-vars';
import Image from '@nerdwallet/react-image';
import { Impression } from '@nerdwallet/analytics/react/impression';

import { HOMEPAGE as analyticsBase } from '../../../lib/analytics-constants';

import HomePageReg from '../../home-page-reg/home-page-reg';

const RegistrationModule = ({
  title,
  subtitle,
  featuredImageDesktop,
  featuredImageMobile,
}) => {
  const imageProps = {
    src: featuredImageDesktop,
    alt: `${title} background image`,
    backgroundColor: 'transparent',
    role: 'presentation',
    lazy: true,
    sources: [
      {
        srcSet: featuredImageMobile,
        media: `(max-width: ${NOT_DESKTOP_MAX_WIDTH}px)`,
      },
      {
        srcSet: featuredImageDesktop,
      },
    ],
  };

  return (
    <Impression
      entityName={analyticsBase.entity_names.registration}
      payload={{
        section_name: analyticsBase.section_name,
        registration_cohort: analyticsBase.cohort,
      }}
    >
      <div className="registration-wrapper">
        <CenteredContainer
          paddingLeft={0}
          paddingRight={0}
          className="registration-module-cont"
        >
          <div className="registration-module">
            <div className="registration-module__text">
              <Title size="small" component="h2">
                {title}
              </Title>
              <div className="registration-module__subtitle">
                <Text>{subtitle}</Text>
              </div>
              <div className="registration-module__subtitle-mobile">
                <Text>{subtitle}</Text>
              </div>
              <div className="auth-container">
                <HomePageReg />
              </div>
              <Image
                {...imageProps}
                className="registration-module-image__mobile"
              />
            </div>
          </div>
          <Image {...imageProps} className="registration-module-image" />
        </CenteredContainer>
      </div>
    </Impression>
  );
};

RegistrationModule.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  featuredImageDesktop: PropTypes.string,
  featuredImageMobile: PropTypes.string,
};

RegistrationModule.displayName = 'RegistrationModule';

export default RegistrationModule;
